import { z } from 'zod';
export const deadlineSourceSchema = z.enum([
    'invoice_due',
    'contract_expiration',
    'ownership_renewal',
    'income_payment',
    'expense_payment',
]);
export const timelineEventSourceSchema = z.enum([
    'user',
    'invoice_due',
    'contract_expiration',
    'ownership_renewal',
    'income_payment',
    'expense_payment',
]);
export const deadlineDismissalActionSchema = z.enum(['completed', 'dismissed']);
export const calendarEventTypeSchema = z.enum(['task', 'expiration', 'event']);
//# sourceMappingURL=calendar.js.map